import { IDeleteEntregaObraClienteTermoUseCase } from "../../../presentation/useCases/delete/delete_entrega_obra_cliente_termo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteEntregaObraClienteTermoUseCase
 */

export class DeleteEntregaObraClienteTermoUseCase implements IDeleteEntregaObraClienteTermoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObraClienteTermo: number): Promise<void> {
    await this.repository.deleteEntregaObrasClienteTermo(idEntregaObraClienteTermo);
  }
}
